// Store
import {
  useIsSurgeryReminderModalOpen,
  useNotificationActions,
  useReminderType,
  useSurgeryActions,
} from 'store/notifications'

// Components
import AlertDialog from 'components/AlertDialog/AlertDialog'

// Router
import { useParams } from 'react-router-dom'

const SurgeryReminderModal = () => {
  const isSurgeryReminderModalOpen = useIsSurgeryReminderModalOpen()
  const reminderType = useReminderType()
  const { toggleNotificationPopup } = useNotificationActions()
  const { onSurgeryReminderConfirm, onSurgeryReminderCancel } =
    useSurgeryActions()
  const { surgeryId } = useParams()
  const secondaryButtonText = 'Cancel'

  const primaryButtonText = reminderType === 'insideCase' ? 'Exit' : 'Logout'

  const handleCancel = () => {
    onSurgeryReminderCancel?.()
  }

  const handleShowOpenProcedures = () => {
    toggleNotificationPopup()
    onSurgeryReminderCancel?.()
  }
  const auxiliaryButtonAction =
    reminderType === 'logout' && !surgeryId
      ? handleShowOpenProcedures
      : undefined

  return (
    <AlertDialog
      isOpen={isSurgeryReminderModalOpen}
      mode="warning"
      title={
        auxiliaryButtonAction ? 'Pending Procedures' : 'Procedure in Progress'
      }
      description={
        reminderType === 'insideCase' || surgeryId
          ? `You have not finalized this procedure. Are you sure you want to exit?`
          : `You have not finalized all your procedures. Are you sure you want to logout?`
      }
      primaryButtonText={primaryButtonText}
      secondaryButtonText={secondaryButtonText}
      secondaryButtonAction={handleCancel}
      primaryButtonAction={onSurgeryReminderConfirm}
      isPrimaryLoading={false}
      auxiliaryButtonAction={auxiliaryButtonAction}
      auxiliaryButtonText="View Procedures"
    />
  )
}

export default SurgeryReminderModal
